import { NgModule } from '@angular/core';
import { ProviderDetailsComponent } from './provider-details.component';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [{ path: '', component: ProviderDetailsComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProviderDetailsRoutingModule { }
